/* eslint-disable max-len */
const getQueryStringValue = (key: string): string => decodeURIComponent(window.location.search.replace(new RegExp(`^(?:.*[&\\?]${encodeURIComponent(key).replace(/[.+*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`, 'i'), '$1'))

export default getQueryStringValue
